import React from "react";
import "./styles/DesignCityContent.scss";
import BannerType1 from "../../../components/BannerType1";
import { useTranslation } from "react-i18next";
const DesignCityContent = () => {
  const { t } = useTranslation();
  const contents = t("design.city.introduction.content", { returnObjects: true }) as { category: string; list: { name: string; textList: string[] }[] }[];
  return (
    <>
      <div className="design_city_content_wrap">
        <BannerType1 path="/imgs/banner_design_city.png" />
        <h2 className="title">{t("design.city.introduction.title")}</h2>
        <div className="content">
          <div className="des">{t("design.city.introduction.des")}</div>
          <div className="card_wrap">
            {contents.map(
              (
                content: {
                  category: string;
                  list: { name: string; textList: string[] }[];
                },
                index: number,
              ) => {
                return (
                  <div className="card" key={`${content.category}_${index}`}>
                    <div className="category">{content.category}</div>
                    <div className="info_wrap">
                      {content.list.map((sub: { name: string; textList: string[] }) => {
                        return (
                          <div className="info" key={`${sub.name}_${index}`}>
                            <div className="name">{sub.name}</div>
                            <ul>
                              {sub.textList.map((text: string, index: number) => {
                                return text !== "" ? <li key={`${text}_${index}`}>{text}</li> : null;
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DesignCityContent;
